import Vue from "vue";
import StarRating from "vue-star-rating";
import FilterBlockLayout from "./fields/FilterBlockLayout.vue";
import FormCustomRelationField from "./fields/FormCustomRelationField.vue";
import FormCustomLocationField from "./fields/FormCustomLocationField.vue";
import FormDistanceField from "./fields/FormDistanceField.vue";
import FormSliderField from "./fields/FormSliderField.vue";
import FormRatingField from "./fields/FormRatingField.vue";
import FormPhonesField from "../../common/FormPhonesField.vue";
import FormYoutubeField from "../../common/FormYoutubeField.vue";
import FormCustomCheckboxField from "./fields/FormCustomCheckboxField.vue";
import FormAgreementField from "./fields/FormAgreementField.vue";
import FormCustomCheckboxesField from "./fields/FormCustomCheckboxesField.vue";
import FormCustomAttachmentField from "./fields/FormCustomAttachmentField.vue";
import FormCustomWorkingHoursField from "./fields/FormCustomWorkingHoursField.vue";
import FormServicesField from "../account/companies/FormServicesField.vue";
import FormOffersField from "../account/companies/FormOffersField.vue";
import FormVatField from "./fields/FormVatField.vue";
import NolabelLayout from "./fields/NolabelLayout.vue";
import FormLocationWithRadius from "./fields/FormLocationWithRadius.vue";
import FormLocationRadiusField from "./fields/FormLocationRadiusField.vue";

Vue.use(require("vue-moment"));
Vue.component("StarRating", StarRating);
Vue.component("FilterBlockLayout", FilterBlockLayout);
Vue.component("FormRelationField", FormCustomRelationField);
Vue.component("FormLocationField", FormCustomLocationField);
Vue.component("FormDistanceField", FormDistanceField);
Vue.component("FormSliderField", FormSliderField);
Vue.component("FormRatingField", FormRatingField);
Vue.component("FormCheckboxField", FormCustomCheckboxField);
Vue.component("FormAgreementField", FormAgreementField);
Vue.component("FormCheckboxesField", FormCustomCheckboxesField);
Vue.component("FormAttachmentField", FormCustomAttachmentField);
Vue.component("FormPhonesField", FormPhonesField);
Vue.component("FormWorkingHoursField", FormCustomWorkingHoursField);
Vue.component("FormServicesField", FormServicesField);
Vue.component("FormOffersField", FormOffersField);
Vue.component("FormVatField", FormVatField);
Vue.component("NolabelLayout", NolabelLayout);
Vue.component("FormYoutubeField", FormYoutubeField);
Vue.component("FormLocationRadiusField", FormLocationRadiusField);
Vue.component("FormLocationWithRadius", FormLocationWithRadius);
